import * as React from "react";
import * as main from "../../main.module.scss";
import * as revs from "./style.module.scss";
import data from "./data.json";
const RevsItem = ({ elem }) => {
  const [isFullText, setIsFullText] = React.useState(false);
  return (
    <>
      <h3>{elem.author}</h3>
      <p>
        {elem.visibleText}
        {elem.hiddenText &&
          (isFullText ? (
            <>
              {elem.hiddenText}
              <br />
              <button
                onClick={() => {
                  setIsFullText(false);
                }}>
                Свернуть
              </button>
            </>
          ) : (
            <>
              ...
              <br />
              <button
                onClick={() => {
                  setIsFullText(true);
                }}>
                Читать полностью
              </button>
            </>
          ))}
      </p>
    </>
  );
};
export const RevsText = () => {
  const swiperEl = React.useRef();
  React.useEffect(() => {
    if (swiperEl.current) {
      Object.assign(swiperEl.current, {
        slidesPerView: 1,
        spaceBetween: 5,
        height: "auto",
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          660: {
            slidesPerView: 2,
            spaceBetween: 20,
          },

          1100: {
            slidesPerView: 3,
            spaceBetween: 30,
          },
        },
      });
      swiperEl.current.initialize();
    }
  }, []);
  return (
    <section className={revs.revs}>
      <div className="container" style={{ position: "unset" }}>
        <h2 className={main.title}>Отзывы<br/> посетивших марафон</h2>
      </div>
      <swiper-wrapper style={{ position: "relative" }}>
        <swiper-container
          ref={swiperEl}
          init="false"
        >
          {data.map((elem, index) => (
            <swiper-slide key={index}>
              <RevsItem elem={elem}/>
            </swiper-slide>
          ))}
        </swiper-container>
        <div className={revs.swiperButtons}>
          <button
            aria-label="swiper-button-prev"
            className={`swiper-button-prev ${revs.swiperBtnPrev}`}
          >
            <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="27.5" cy="27.5" r="27.5" transform="matrix(0 -1 -1 0 55 55)" fill="#FF7238"/>
              <path d="M30.4912 34.9015C30.3985 34.9959 30.2884 35.0708 30.1672 35.1218C30.046 35.1729 29.9161 35.1992 29.7849 35.1992C29.6537 35.1992 29.5238 35.1729 29.4026 35.1218C29.2814 35.0708 29.1713 34.9959 29.0786 34.9015L22.2928 28.0062C22.2 27.9119 22.1263 27.8 22.0761 27.6767C22.0259 27.5535 22 27.4214 22 27.288C22 27.1546 22.0259 27.0225 22.0761 26.8993C22.1263 26.776 22.2 26.6641 22.2928 26.5698L29.0786 19.6745C29.1705 19.5763 29.2807 19.4979 29.4029 19.4438C29.525 19.3896 29.6566 19.3609 29.7898 19.3593C29.9231 19.3577 30.0553 19.3832 30.1787 19.4344C30.302 19.4855 30.4141 19.5613 30.5082 19.6572C30.6024 19.7531 30.6767 19.8672 30.7268 19.9927C30.7769 20.1183 30.8017 20.2528 30.7999 20.3882C30.7981 20.5237 30.7696 20.6575 30.7162 20.7816C30.6627 20.9057 30.5854 21.0177 30.4887 21.1109L24.4091 27.288L30.4887 33.4651C30.5817 33.5592 30.6555 33.671 30.7059 33.7942C30.7564 33.9173 30.7825 34.0494 30.7827 34.1828C30.7829 34.3162 30.7573 34.4483 30.7073 34.5716C30.6573 34.695 30.5838 34.807 30.4912 34.9015Z" fill="white"/>
            </svg>
          </button>
          <button
            aria-label="swiper-button-next"
            className={`swiper-button-next ${revs.swiperBtnNext}`}
          >
            <svg width="55" height="55" viewBox="0 0 55 55" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="27.5" cy="27.5" r="27.5" transform="rotate(-90 27.5 27.5)" fill="#FF7238"/>
              <path d="M24.5088 34.9015C24.6015 34.9959 24.7116 35.0708 24.8328 35.1218C24.954 35.1729 25.0839 35.1992 25.2151 35.1992C25.3463 35.1992 25.4762 35.1729 25.5974 35.1218C25.7186 35.0708 25.8287 34.9959 25.9214 34.9015L32.7072 28.0062C32.8 27.9119 32.8737 27.8 32.9239 27.6767C32.9741 27.5535 33 27.4214 33 27.288C33 27.1546 32.9741 27.0225 32.9239 26.8993C32.8737 26.776 32.8 26.6641 32.7072 26.5698L25.9214 19.6745C25.8295 19.5763 25.7193 19.4979 25.5971 19.4438C25.475 19.3896 25.3434 19.3609 25.2102 19.3593C25.0769 19.3577 24.9447 19.3832 24.8213 19.4344C24.698 19.4855 24.5859 19.5613 24.4918 19.6572C24.3976 19.7531 24.3233 19.8672 24.2732 19.9927C24.2231 20.1183 24.1983 20.2528 24.2001 20.3882C24.2019 20.5237 24.2304 20.6575 24.2838 20.7816C24.3373 20.9057 24.4146 21.0177 24.5113 21.1109L30.5909 27.288L24.5113 33.4651C24.4183 33.5592 24.3445 33.671 24.2941 33.7942C24.2436 33.9173 24.2175 34.0494 24.2173 34.1828C24.2171 34.3162 24.2427 34.4483 24.2927 34.5716C24.3427 34.695 24.4162 34.807 24.5088 34.9015Z" fill="white"/>
            </svg>
          </button>
        </div>
      </swiper-wrapper>
    </section>
  );
};
